export default __webpack_public_path__ + "static/media/leftActive.040f0ab0.svg";